import z from 'zod';

// Marks a setting the merchant's configuration doesn't support - e.g. a feature that isn't enabled
// on their plan. A setting flagged `true` is dropped before submission so the stored value is left
// untouched. `true | undefined` is chosen here over `boolean` as `false` would be forwarded to the
// API. `undefined` will not be JSON encoded, so we don't have to filter it out later
export const disabledFlag = () => z.literal(true).optional();
